var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIfsiconTh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6471_7738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.503 63.691L182.504 52.6602H217.626L268.184 104.137V297.177H182.5L182.502 286.146H257.153V111.491H209.353V63.691H182.503Z",
    fill: "#9901F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.379 70.125V100.46H249.795L220.379 70.125Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87206 94.9471H0.679688V0.265625H96.2804V10.3772H9.87206V94.9471Z",
    fill: "url(#paint0_linear_6471_7738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.335 254.893H349.527V349.574H253.927V339.463H340.335V254.893Z",
    fill: "url(#paint1_linear_6471_7738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.846 9.458V0.265625L349.527 0.265629V95.8663H339.416V9.458H254.846Z",
    fill: "url(#paint2_linear_6471_7738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3612 340.382V349.574H0.679692L0.679688 253.974H10.7913V340.382H95.3612Z",
    fill: "url(#paint3_linear_6471_7738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.851 344.06V5.78107C180.851 2.73498 178.382 0.265625 175.336 0.265625C172.29 0.265625 169.82 2.73498 169.82 5.78108V344.06C169.82 347.106 172.29 349.576 175.336 349.576C178.382 349.576 180.851 347.106 180.851 344.06Z",
    fill: "#9901F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.982 287.069V62.7744C167.982 57.6976 163.867 53.582 158.79 53.582C153.713 53.582 149.598 57.6976 149.598 62.7744V287.069C149.598 292.145 153.713 296.261 158.79 296.261C163.867 296.261 167.982 292.145 167.982 287.069Z",
    fill: "#9901F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.756 289.826V60.0167C147.756 56.4629 144.875 53.582 141.321 53.582C137.768 53.582 134.887 56.4629 134.887 60.0167V289.826C134.887 293.38 137.768 296.261 141.321 296.261C144.875 296.261 147.756 293.38 147.756 289.826Z",
    fill: "#9901F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.209 289.826V60.0167C131.209 56.4629 128.328 53.582 124.774 53.582C121.221 53.582 118.34 56.4629 118.34 60.0167V289.826C118.34 293.38 121.221 296.261 124.774 296.261C128.328 296.261 131.209 293.38 131.209 289.826Z",
    fill: "#9901F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.988 290.746V59.0975C110.988 56.0514 108.519 53.582 105.472 53.582C102.426 53.582 99.957 56.0514 99.957 59.0975V290.746C99.957 293.792 102.426 296.261 105.472 296.261C108.519 296.261 110.988 293.792 110.988 290.746Z",
    fill: "#9901F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.768 292.584V57.259C90.768 55.2283 89.1217 53.582 87.091 53.582C85.0603 53.582 83.4141 55.2282 83.4141 57.259V292.584C83.4141 294.615 85.0603 296.261 87.091 296.261C89.1217 296.261 90.768 294.615 90.768 292.584Z",
    fill: "#9901F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.499 63.5L182 63V286.5H257.499V111.5H209.499V63.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6471_7738",
    x1: 0.679688,
    y1: 94.9471,
    x2: 95.3567,
    y2: -0.649156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A200FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6471_7738",
    x1: 253.927,
    y1: 349.574,
    x2: 348.603,
    y2: 253.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A200FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6471_7738",
    x1: 254.846,
    y1: 95.8663,
    x2: 350.442,
    y2: 1.18972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A200FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6471_7738",
    x1: 0.679688,
    y1: 349.574,
    x2: 96.2752,
    y2: 254.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#381576"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A200FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6471_7738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfsiconTh);
export default __webpack_public_path__ + "static/media/IFS ICON_TH.ed43c8e0be8f8d16ef58fe149889fa75.svg";
export { ForwardRef as ReactComponent };